import { View, Text, Image, StyleSheet } from "@react-pdf/renderer";
import type { PdfWidgetSnapshot } from "../pdfTypes";
import type { PdfRect } from "../pdfLayout";

const s = StyleSheet.create({
  cell: {
    position: "absolute",
    borderWidth: 1,
    borderColor: "#e8e8e8",
    borderRadius: 4,
    backgroundColor: "#fff",
    overflow: "hidden",
  },
  logoWrap: { alignItems: "center", justifyContent: "center" },
  logoImage: { objectFit: "contain" },
  titleText: { fontWeight: 700, color: "#1a1a1a", textAlign: "center" },
});

export function renderLogo(
  snapshot: Extract<PdfWidgetSnapshot, { type: "logo" }>,
  rect: PdfRect,
  _scale: number,
) {
  const pad = 2;
  const imgSize = Math.min(rect.width, rect.height) - 2 * pad;
  return (
    <View style={[s.cell, s.logoWrap, { left: rect.left, top: rect.top, width: rect.width, height: rect.height }]}>
      {snapshot.logoUrl ? (
        <Image
          src={snapshot.logoUrl}
          style={[s.logoImage, { width: imgSize, height: imgSize }]}
        />
      ) : (
        <Text style={[s.titleText, { fontSize: imgSize * 0.35 }]}>
          {snapshot.initials}
        </Text>
      )}
    </View>
  );
}
